import $ from "jquery";
import { isNotPC } from "./ua";


export default class ReadMore {
  constructor() {}

  init() {
    const $readMore = $(".js-readmore-toggle");

    if (isNotPC()) {
      $(".js-accordion6").removeClass("hidden");
      this.textHeight6 = $(".js-accordion6").height();
      $(".js-accordion6").addClass("hidden");
    }
    
    // $(".js-accordion6").css("height", this.textHeight6);

    $readMore.change((e) => {
      const $self = $(e.target);
      const value = $self.data("value");
      const $target = $(`.js-accordion${value}`);
      const $contents = $(`.js-contents${value}`);

      if ($self.is(":checked")) {
        if (value === 6) {
          $target.css("height", this.textHeight6);
        }

        $target.removeClass("hidden");
        $target.addClass("show");
        $contents.removeClass("is-close");
        $contents.addClass("is-open");

        if (value === 6) {
          $target.css("height", this.textHeight6);
        }
      } else {
        $target.removeClass("show");
        $target.addClass("hidden");
        $contents.removeClass("is-open");
        $contents.addClass("is-close");

        if (value === 6) {
          $target.css("height", 0);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/ReadMore.js